import { useMemo, useState } from 'react'
import localStorage from 'local-storage'
import { getElapsedTime } from 'date'
import { processError } from 'helpers'
import { useSubscription } from 'modules/subscription'
import { useSetPopupShown, useShownPopups, useUser } from 'modules/user'

import useOrderItems from 'compositions/orderItems/util/useOrderItems'


const useCartItems = (cart: CartModule.Cart) => {
  const { isLoggedIn } = useUser()
  const orderItems = useOrderItems(cart)

  const { subscription } = useSubscription()
  const { shownPopups } = useShownPopups()
  const setPopupShown = useSetPopupShown()

  const [ subscriptionBannerWasShownInSession, setSubscriptionBannerWasShownInSession ] = useState(() => localStorage.getSessionItem('isCartSubscriptionBannerShown'))

  const isSubscriptionBannerEnabled = Boolean(subscription?.hasNeverSubscribed && !orderItems.subscription)

  const subscriptionBanner = useMemo(() => {
    if (!isSubscriptionBannerEnabled || subscriptionBannerWasShownInSession) {
      return null
    }

    const popupName = 'cartSubscriptionBanner'
    const lastUpdated = shownPopups[popupName]?.lastUpdated

    // hide popup for 24 hours
    if (lastUpdated && getElapsedTime(lastUpdated, 'hours') < 24) {
      return null
    }

    return {
      onCancel: async () => {
        try {
          if (isLoggedIn) {
            await setPopupShown(popupName)
          }
          else {
            setSubscriptionBannerWasShownInSession(true)
            localStorage.setSessionItem('isCartSubscriptionBannerShown', true)
          }
        }
        catch (error) {
          processError(error)
        }
      },
    }
  }, [ isSubscriptionBannerEnabled, subscriptionBannerWasShownInSession, shownPopups, isLoggedIn, setPopupShown ])

  return {
    orderItems,
    subscriptionBanner,
  }
}


export default useCartItems
